<template>
  <div class="row w-100 flex-column pt-5">
      <form id="" class="row w-100 flex-column" v-on:submit.prevent="submit">
          <div class="row align-items-center mb-4 mr-auto ml-auto col-4 mb-3">
              <label  class="ml-4 p-list-representation-label-text w-100 mb-2">
               نام کاربری
              </label>
              <input v-model="formData.mobile" type="text" placeholder="" class="form-control text-right pl-2 pr-2 w-100">
           </div>
           <div class="row align-items-center mb-4 mr-auto ml-auto col-4 ">
               <label class="ml-4 p-list-representation-label-text w-100 mb-2">
                پسورد
               </label>
               <input v-model="formData.password" type="password" placeholder="" class="form-control text-right pl-2 pr-2 w-100">
            </div>

            <div class="w-100 row justify-content-center mt-3">
              <button type="submit" class="btn btn-primary btn-blue col-lg-2">ورود</button>
           </div>
       </form>
  </div>
</template>

<script>



export default {
  name: "contentList",
  components: {

  },

  props: {

  },

  data() {
    return {
      formData  : {
        mobile    : '',
        password  : '',
      }
    }
  },

  watch: {

  },

  created() {

  },

  mounted() {
  },


  methods: {
    submit(){
      this.$emit('submit',this.formData);
    }

  }


}
</script>
